"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escape = void 0;
const assertString_1 = require("./util/assertString");
function escape(str) {
    (0, assertString_1.assertString)(str);
    return (str.replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#x27;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\//g, '&#x2F;')
        .replace(/\\/g, '&#x5C;')
        .replace(/`/g, '&#96;'));
}
exports.escape = escape;
